import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { ChangeUserRoleGroupInput } from '../generated/globalTypes';
import { userFieldsFragment } from "../models/User";
import { changeUserRoleGroupMutationVariables, changeUserRoleGroupMutation } from "../generated/changeUserRoleGroupMutation";
import { useResetCurrentUserRolesCallback } from "../../account";

/**
 * Get a callback to change the role grup of a user in the store.
 */
export function useChangeUserRoleGroupCallback(): [(model: ChangeUserRoleGroupInput) => Promise<void>, AsyncActionStatus] {
    const resetCurrentUserRoles = useResetCurrentUserRolesCallback();

    const [mutationAction, { error }] = useMutation<changeUserRoleGroupMutation, changeUserRoleGroupMutationVariables>(
        gql`
            mutation changeUserRoleGroupMutation ($model: ChangeUserRoleGroupInput!) {
                changeUserRoleGroup(model: $model) {
                    ...userFields
                }
            }

            ${userFieldsFragment}
        `,
        {
            update: () => resetCurrentUserRoles()
        }
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: ChangeUserRoleGroupInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
